// A base for webcomponents
export default class WebComponent extends HTMLElement {
    props = {};
    static observedAttrs = [];
    slots = {};

    // Sets opserver for html attrs
    static get observedAttributes() {
        return this.observedAttrs;
    }

    // Updates values from opserved html attrs
    attributeChangedCallback(property, oldValue, newValue) {
        if (oldValue === newValue) return;
        this[ property ] = newValue;

        if(this.render) this.render();
    }

    // connect component
    async connectedCallback() {
        if(this.init) await this.init();
        if(this.render) this.render();
    }

    // Helper for rendering conditional css classes 
    classNames(classesArr) {
        return classesArr.filter(entry => entry[Object.keys(entry)[0]]).map((entry) => Object.keys(entry)[0])
    }

    // Helper for sending complex props to nested webcomponent 
    setTargetProps({target, props}) {
        this.querySelector(target)?.setProps(props)
    }

    // Helper for receiving complex props from parent webcomponent
    setProps(props) {
        this.props = props;
        if(this.render) this.render();
    }

    // Helper for rendering an array of elements
    wFor(arr, handler) {
        return arr.map(handler).join('');
    }

    storeSlots() {
        const slots = this.querySelectorAll('slot');
        for (let index = 0; index < slots.length; index++) this.slots[slots[index].getAttribute("name") || 'default'] = slots[index];
    }

    // render function to standardised callbacks
    async render() {
        this.storeSlots();
        if(this.beforeMount) await this.beforeMount();
        if(this.template) this.innerHTML = await this.template();
        if(this.mounted) this.mounted();
    }
}